/* jshint esversion: 6 */
import develop from './config'

let success = (...arg) => {
  if (develop.dev === 'online') return
  if (arg.length > 1) {
    if (arg[1] instanceof String) {
      let text = arg.shift()
      console.log(`${text} \x1B[32m%s\x1B[39m`, ...arg)
    } else {
      console.log(`\x1B[32m%s\x1B[39m`, ...arg)
    }
  } else {
    console.log(typeof arg[0] === 'string' ? `\x1B[32m%s\x1B[39m` : '', ...arg)
  }
  // return false
}

let error = (...arg) => {
  if (develop.dev === 'online') return
  if (arg.length > 1) {
    if (arg[1] instanceof String) {
      let text = arg.shift()
      console.log(`${text} \x1B[41m%s\x1B[49m`, ...arg)
    } else {
      console.log(`\x1B[41m%s\x1B[49m`, ...arg)
    }
  } else {
    console.log(typeof arg[0] === 'string' ? `\x1B[41m%s\x1B[49m` : '', ...arg)
    // console.log('错误信息 \x1B[41m%s\x1B[49m', arg[0])
  }
  // return false
}
// export default develop
export default {
  success,
  error
}



// WEBPACK FOOTER //
// ./src/util/jconsole.js